// `/` → redirect to the default-locale app root. Every real URL is
// locale-prefixed (/ar/* or /en/*), so the bare root just bounces.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { DEFAULT_LOCALE } from '~/lib/locale';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/$locale', params: { locale: DEFAULT_LOCALE } });
  },
});
